




















































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  GET_USER_TYPE_LIST,
  SET_SELECTED_USER_TYPE,
  UPDATE_REGISTER_FORM_VISIBILITY,
  GET_REGISTER_FORM_VISIBILITY,
  FETCH_USER_TYPE_LIST,
  CREATE_USER_TYPE_LIST,
} from '@/modules/user-type/store';
import { IUserType } from '@/modules/user-type/models';
import { RootState } from '@/store';
import { getEnabledCategories } from 'trace_events';
import { UtilService } from '@/services/util';
import { nameof } from 'ts-simple-nameof';

@Component
export default class extends Vue {
  public isLoading: boolean = false;
  public showRegisterForm: boolean = false;
  public state = {};
  public search: string = '';
  public selected: any[] = [];
  public headersStores: any[] = [
    { text: 'Nome', value: nameof<IUserType>((c) => c.usertypename) },
    { text: 'Status', value: nameof<IUserType>((c) => c.isactive) },
  ];

  public pagination: any = {
    sortBy: nameof<IUserType>((c) => c.usertypename),
    descending: false,
  };

  @Getter(GET_USER_TYPE_LIST)
  public userTypes: IUserType[];

  @Getter(GET_REGISTER_FORM_VISIBILITY)
  public showUserTypeForm: boolean;

  @Action(FETCH_USER_TYPE_LIST)
  private getAllUserTypes: any;

  @Action(CREATE_USER_TYPE_LIST)
  private setAllUserTypes: any;

  @Action(SET_SELECTED_USER_TYPE)
  private setSelectedUser: any;

  @Action(UPDATE_REGISTER_FORM_VISIBILITY)
  private setShowUserTypeForm: any;

  public created() {
    this.isLoading = true;
    this.getAllUserTypes().then((ret: any) => {

      const types: IUserType[] = ret[0].data;
      this.setAllUserTypes(types);

    }).finally(() => {
      this.isLoading = false;
    });
  }

  public habilitarCadastro() {
    this.setShowUserTypeForm(!this.showUserTypeForm);
  }

  public selectUserType(selectedUser: IUserType) {
    this.setSelectedUser(selectedUser);
    this.setShowUserTypeForm(true);
  }

  public getBadgeColor(icatv: boolean) {
    return icatv ? 'teal' : 'red';
  }
}
